export default {
  querySaleList: '/gateway/capp/mallcenter/GoodsSaleForAppRpcService/querySaleList'

}
